import { render } from "./HospitalAdmins.vue?vue&type=template&id=662aee1a"
import script from "./HospitalAdmins.vue?vue&type=script&lang=js"
export * from "./HospitalAdmins.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/admins/HospitalAdmins.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "662aee1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('662aee1a', __exports__)) {
    console.log('reload')
    api.reload('662aee1a', __exports__)
  }
  
  module.hot.accept("./HospitalAdmins.vue?vue&type=template&id=662aee1a", () => {
    console.log('re-render')
    api.rerender('662aee1a', render)
  })

}


export default __exports__